import { render, staticRenderFns } from "./adsCard.vue?vue&type=template&id=3b234135&scoped=true"
import script from "./adsCard.vue?vue&type=script&lang=js"
export * from "./adsCard.vue?vue&type=script&lang=js"
import style0 from "./adsCard.vue?vue&type=style&index=0&id=3b234135&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b234135",
  null
  
)

export default component.exports